import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './hourly-product-usage.reducer';

export const HourlyProductUsageDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const hourlyProductUsageEntity = useAppSelector(state => state.hourlyProductUsage.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="hourlyProductUsageDetailsHeading">
          <Translate contentKey="crawlerBackendApp.hourlyProductUsage.detail.title">HourlyProductUsage</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{hourlyProductUsageEntity.id}</dd>
          <dt>
            <span id="from">
              <Translate contentKey="crawlerBackendApp.hourlyProductUsage.from">From</Translate>
            </span>
          </dt>
          <dd>
            {hourlyProductUsageEntity.from ? (
              <TextFormat value={hourlyProductUsageEntity.from} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="util">
              <Translate contentKey="crawlerBackendApp.hourlyProductUsage.util">Util</Translate>
            </span>
          </dt>
          <dd>
            {hourlyProductUsageEntity.util ? (
              <TextFormat value={hourlyProductUsageEntity.util} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="hourlyUsage">
              <Translate contentKey="crawlerBackendApp.hourlyProductUsage.hourlyUsage">Hourly Usage</Translate>
            </span>
          </dt>
          <dd>{hourlyProductUsageEntity.hourlyUsage}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.hourlyProductUsage.tariff">Tariff</Translate>
          </dt>
          <dd>{hourlyProductUsageEntity.tariff ? hourlyProductUsageEntity.tariff.id : ''}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.hourlyProductUsage.product">Product</Translate>
          </dt>
          <dd>{hourlyProductUsageEntity.product ? hourlyProductUsageEntity.product.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/hourly-product-usage" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/hourly-product-usage/${hourlyProductUsageEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default HourlyProductUsageDetail;
